<script setup lang="ts">
import { PlayIcon } from '@glow/shared/components/icons';
import { useEventListener } from '@vueuse/core';

const props = defineProps<{
  src: string;
  isPlaying?: boolean;
}>();
const emit = defineEmits<{
  (e: 'play'): void;
  (e: 'stop'): void;
}>();

const videoRef = ref<HTMLVideoElement>();

watch(
  () => props.isPlaying,
  (isPlaying) => {
    const video = videoRef.value;
    if (!video) return;
    if (isPlaying) video.play();
    else {
      video.pause();
      video.currentTime = 0;
    }
  },
  { immediate: true }
);

useEventListener(videoRef, 'click', () => {
  if (!props.isPlaying) return;
  emit('stop');
});
</script>

<template>
  <div class="video">
    <video ref="videoRef" :src="props.src" />
    <AppButton
      v-if="!props.isPlaying"
      variant="secondary"
      :icon-start="PlayIcon"
      class="play-button"
      @click="emit('play')"
    />
  </div>
</template>

<style scoped lang="scss">
.video {
  position: relative;
  height: 100%;

  video {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  .play-button {
    position: absolute;
    top: 50%;
    right: 50%;
    transform: translate(50%, -50%);
    border-radius: 100%;
    padding: 0.5em;
  }
}
</style>
